import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

/**
 * Sober DS (v2) — Skeleton. Pure-CSS shimmer placeholder using the shared
 * `animate-shimmer` keyframe. Neutral muted surface with a translucent white
 * sweep overlay; line / block size variants.
 */
const skeletonVariants = cva('relative overflow-hidden bg-sober-muted', {
  variants: {
    variant: {
      line: 'h-3 rounded-so-sm',
      block: 'h-20 rounded-so-md',
    },
  },
  defaultVariants: { variant: 'line' },
});

export interface SkeletonProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof skeletonVariants> {}

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, variant, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden="true"
      className={cn(skeletonVariants({ variant }), className)}
      {...props}
    >
      <span className="absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-white/40 to-transparent" />
    </div>
  )
);
Skeleton.displayName = 'Skeleton';

export { skeletonVariants };
